"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var DropdownSelect_1 = require("./dropdownSelect/DropdownSelect");
var InputField_1 = require("./inputField/InputField");
var CustomCheckbox_1 = require("./customCheckbox/CustomCheckbox");
var DatePicker_1 = require("../../../common/components/dateField/DatePicker");
var InputFieldWithHyphen_1 = require("./inputFieldWithHyphen/InputFieldWithHyphen");
var AutocompleteInput_1 = require("./autocompleteInput/AutocompleteInput");
var PhoneWIthPrefixInput_1 = require("./phoneWithPrefixField/PhoneWIthPrefixInput");
var MarkdownText_1 = require("./markdownText/MarkdownText");
var CustomCheckboxes_1 = require("./customCheckboxes/CustomCheckboxes");
var TextareaInput_1 = require("./textareaInput/TextareaInput");
var CustomRadioButton_1 = require("./customRadioButton/CustomRadioButton");
var CustomRadioGroup_1 = require("./customRadioGroup/CustomRadioGroup");
var TextareaAutosizeInput_1 = require("./textareaAutosizeInput/TextareaAutosizeInput");
var CustomComponentsMapper = function () {
    return {
        TextWidget: function (inputData) { return <InputField_1.default formData={inputData}/>; },
        SelectWidget: function (selectData) { return <DropdownSelect_1.default formData={selectData}/>; },
        CheckboxWidget: function (checkboxData) { return <CustomCheckbox_1.CustomCheckbox formData={checkboxData}/>; },
        CheckboxesWidget: function (checkboxData) { return <CustomCheckboxes_1.default formData={checkboxData}/>; },
        EmailWidget: function (emailData) { return <InputField_1.default formData={emailData}/>; },
        DateWidget: function (dateData) { return <DatePicker_1.default formData={dateData}/>; },
        InputWithHyphen: function (inputData) { return <InputFieldWithHyphen_1.default formData={inputData}/>; },
        Autocomplete: function (inputData) { return <AutocompleteInput_1.default formData={inputData}/>; },
        PhoneWithPrefix: function (inputData) { return <PhoneWIthPrefixInput_1.default formData={inputData}/>; },
        MarkdownText: function (inputData) { return <MarkdownText_1.default formData={inputData}/>; },
        TextareaWidget: function (inputData) { return <TextareaInput_1.default formData={inputData}/>; },
        TextareaAutosizeWidget: function (inputData) { return <TextareaAutosizeInput_1.default formData={inputData}/>; },
        RadioWidget: function (radioData) { return <CustomRadioButton_1.default formData={radioData}/>; },
        RadioGroupWidget: function (radioData) { return <CustomRadioGroup_1.default formData={radioData}/>; },
    };
};
exports.default = CustomComponentsMapper;
